import React, { Fragment, useEffect, useState, Suspense } from "react";
 

const Card = React.lazy(() => import('../components/Card'));
const Filter = React.lazy(() => import('../components/Filter'));


const Archive = () => {
  const [objects, setObjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedCollection, setSelectedCollection] = useState(''); 
  const [selectedKeyword, setSelectedKeyword] = useState(''); 
  const [selectedRestype, setSelectedRestype] = useState(''); 
  const [selectedSubcat, setSelectedSubcat] = useState(''); 
  const [selectedMediatype, setSelectedMediatype] = useState(''); 
  const [selectedCountry, setSelectedCountry] = useState(''); 
  const [selectedCity, setSelectedCity] = useState(''); 
  const [selectedCreator, setSelectedCreator] = useState(''); 
  const [selectedRecorder, setSelectedRecorder] = useState(''); 
  const [numberOfObjects, setNumberOfObjects] = useState(0);


  const fetchObjects = async (project = '', collection = '', keyword = '', restype = '', subcat = '', mediatype = '', country = '', city = '', creator = '', recorder = '') => {
    try {
      const response = await fetch(`/api/archive?project=${project}&collection=${collection}&keyword=${keyword}&restype=${restype}&subcat=${subcat}&mediatype=${mediatype}&country=${country}&city=${city}&creator=${creator}&recorder=${recorder}`); // Update your endpoint accordingly
      const jsonData = await response.json();
      setNumberOfObjects(jsonData.length);
      setObjects(jsonData);      
    } catch (err) {
      console.error("Error fetching objects:", err);
    }
  };

  useEffect(() => {
    fetchObjects();  
  }, []);

  const handleFilterChange = (project, collection, keyword, restype, subcat, mediatype, country, city, creator, recorder) => { 
    setSelectedProject(project);
    setSelectedCollection(collection);
    setSelectedKeyword(keyword);
    setSelectedRestype(restype);
    setSelectedSubcat(subcat);
    setSelectedMediatype(mediatype);
    setSelectedCountry(country);
    setSelectedCity(city);
    setSelectedCreator(creator);
    setSelectedRecorder(recorder);
    fetchObjects(project, collection, keyword, restype, subcat, mediatype, country, city, creator, recorder); 
  };

  const toggleFilter = () => {
    const filterSpace = document.querySelector('.filter_space');
    filterSpace.classList.toggle('open');
  };

  const closeFilterOnSelection = () => {
    const filterSpace = document.querySelector('.filter_space');
    if (filterSpace.classList.contains('open')) {
      filterSpace.classList.remove('open');
    }
  };



  return (
    <Fragment>
      
      <div className="container">
      
      <button className="filter-toggle" onClick={toggleFilter}>
          Filter
        </button>
        <Suspense fallback={<div>Loading Filter...</div>}>
        <Filter onFilterChange={(...args) => {
          handleFilterChange(...args);
          closeFilterOnSelection();
        }} />
        </Suspense>
        <div className="cards_space">
        <h1>Archive</h1>
          <div className="wrapper">
          <p id="count" >Number of items: {numberOfObjects}</p>
          <div className="csrow">
          <Suspense fallback={<div>Loading Items...</div>}>
              {objects.map(object => {
                const media = object.media ? 'thumb_' + object.media.split(',')[0] : '';  
                
                return (
                  <Card
                    key={object.obj_id}
                    id={object.obj_id}
                    ref_id={object.ref_id}
                    title={object.title}
                    media={media}  
                    media_type={object.med_name}
                    project={object.prj_name}
                    record_date={object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                  />
                );
              })}
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};



export default Archive;
